/* Pruden & Smith — custom header (single source of truth = #ps-nav-data JSON) */
(function(){
  const root = document.getElementById('psNav');
  if(!root) return;
  let NAV = [];
  try { NAV = JSON.parse(document.getElementById('ps-nav-data').textContent); } catch(e){ NAV = []; }

  const G = {
    round:`<svg viewBox="-1.75 -1.75 27.5 27.5"><circle cx="12" cy="12" r="11"/><polygon points="15.51,13.45 13.45,15.51 10.55,15.51 8.49,13.45 8.49,10.55 10.55,8.49 13.45,8.49 15.51,10.55"/><line x1="15.51" y1="13.45" x2="22.16" y2="16.21"/><line x1="13.45" y1="15.51" x2="16.21" y2="22.16"/><line x1="10.55" y1="15.51" x2="7.79" y2="22.16"/><line x1="8.49" y1="13.45" x2="1.84" y2="16.21"/><line x1="8.49" y1="10.55" x2="1.84" y2="7.79"/><line x1="10.55" y1="8.49" x2="7.79" y2="1.84"/><line x1="13.45" y1="8.49" x2="16.21" y2="1.84"/><line x1="15.51" y1="10.55" x2="22.16" y2="7.79"/><line x1="15.51" y1="12" x2="23" y2="12"/><line x1="12" y1="15.51" x2="12" y2="23"/><line x1="8.49" y1="12" x2="1" y2="12"/><line x1="12" y1="8.49" x2="12" y2="1"/></svg>`,
    oval:`<svg viewBox="2.3 2.3 19.5 19.5"><ellipse cx="12" cy="12" rx="7" ry="9"/><ellipse cx="12" cy="12" rx="3.3" ry="4.4"/><line x1="15.3" y1="12" x2="19" y2="12"/><line x1="8.7" y1="12" x2="5" y2="12"/><line x1="12" y1="16.4" x2="12" y2="21"/><line x1="12" y1="7.6" x2="12" y2="3"/><line x1="14.33" y1="15.11" x2="16.95" y2="18.36"/><line x1="9.67" y1="15.11" x2="7.05" y2="18.36"/><line x1="9.67" y1="8.89" x2="7.05" y2="5.64"/><line x1="14.33" y1="8.89" x2="16.95" y2="5.64"/></svg>`,
    emerald:`<svg viewBox="1.38 1.38 21.25 21.25"><polygon points="8,3.5 16,3.5 20.5,8 20.5,16 16,20.5 8,20.5 3.5,16 3.5,8"/><polygon points="9.2,6.05 14.8,6.05 17.95,9.2 17.95,14.8 14.8,17.95 9.2,17.95 6.05,14.8 6.05,9.2"/><polygon points="11,9.4 13,9.4 14.6,11 14.6,13 13,14.6 11,14.6 9.4,13 9.4,11"/><line x1="20.5" y1="8" x2="17.95" y2="9.2"/><line x1="20.5" y1="16" x2="17.95" y2="14.8"/><line x1="3.5" y1="8" x2="6.05" y2="9.2"/><line x1="3.5" y1="16" x2="6.05" y2="14.8"/></svg>`,
    pear:`<svg viewBox="3.33 2.33 17.33 17.33"><path d="M12 3.2c2.7 2.5 5.6 5.7 5.6 9.9a5.6 5.6 0 0 1-11.2 0c0-4.2 2.9-7.4 5.6-9.9z"/><ellipse cx="12" cy="13.6" rx="2.7" ry="3.1"/><line x1="12" y1="3.2" x2="9.3" y2="12.2"/><line x1="12" y1="3.2" x2="14.7" y2="12.2"/><line x1="9.3" y1="15.3" x2="7.4" y2="17"/><line x1="14.7" y1="15.3" x2="16.6" y2="17"/><line x1="12" y1="16.7" x2="12" y2="18.8"/></svg>`,
    cushion:`<svg viewBox="2 2 20 20"><rect x="4" y="4" width="16" height="16" rx="6"/><rect x="8.2" y="8.2" width="7.6" height="7.6" rx="2.4"/><line x1="6.3" y1="6.3" x2="8.7" y2="8.7"/><line x1="17.7" y1="6.3" x2="15.3" y2="8.7"/><line x1="17.7" y1="17.7" x2="15.3" y2="15.3"/><line x1="6.3" y1="17.7" x2="8.7" y2="15.3"/></svg>`,
    marquise:`<svg viewBox="2.27 2.27 19.46 19.46"><path d="M12 3 C16.5 7 18 10 18 12 C18 14 16.5 17 12 21 C7.5 17 6 14 6 12 C6 10 7.5 7 12 3 Z"/><ellipse cx="12" cy="12" rx="3" ry="4"/><line x1="12" y1="3" x2="12" y2="7.6"/><line x1="12" y1="16.4" x2="12" y2="21"/><line x1="9" y1="12" x2="6" y2="12"/><line x1="15" y1="12" x2="18" y2="12"/></svg>`,
    princess:`<svg viewBox="2.62 2.62 18.75 18.75"><rect x="4.5" y="4.5" width="15" height="15"/><line x1="4.5" y1="4.5" x2="19.5" y2="19.5"/><line x1="19.5" y1="4.5" x2="4.5" y2="19.5"/><polygon points="12,8.4 15.6,12 12,15.6 8.4,12"/></svg>`
  };
  const METAL = {'Platinum':'#D8D8D8','18k Yellow Gold':'#E8C766','18k White Gold':'#ECECEC','18k Rose Gold':'#E7B7A3','Yellow Gold':'#E8C766','White Gold':'#ECECEC','Rose Gold':'#E7B7A3'};
  const BORDERED = {'Platinum':1,'18k White Gold':1,'White Gold':1};
  const GEM = `<svg viewBox="0 0 24 24"><polygon points="6,9 12,3 18,9 12,21"/><line x1="6" y1="9" x2="18" y2="9"/><line x1="12" y1="3" x2="9" y2="9"/><line x1="12" y1="3" x2="15" y2="9"/></svg>`;
  const chev=`<svg class="chev" viewBox="0 0 24 24"><polyline points="9,5 16,12 9,19"/></svg>`;
  const backArrow=`<svg viewBox="0 0 24 24"><polyline points="15,5 8,12 15,19"/></svg>`;
  const fadeChev=`<svg viewBox="0 0 24 24"><polyline points="6,9 12,15 18,9"/></svg>`;
  const enc = s => (s||'').replace(/"/g,'&quot;');
  const slug = s => (s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-');
  const SHAPE = {round:'round',oval:'oval',emerald:'emerald',pear:'pear',cushion:'cushion',princess:'princess',marquise:'marquise'};
  const adorn = (name,glyph) => {
    if(glyph && G[glyph]) return `<span class="glyph">${G[glyph]}</span>`;
    const key=(name||'').trim().toLowerCase();
    if(SHAPE[key]) return `<span class="glyph">${G[SHAPE[key]]}</span>`;
    if(METAL[name]!==undefined) return `<span class="metal" style="background:${METAL[name]};${BORDERED[name]?'border:0.5px solid #b3b0a7':''}"></span>`;
    return '';
  };
  const url = it => it[1] || '#';
  const dleaf = it => `<a class="dk-leaf" href="${url(it)}">${adorn(it[0],it[2])}<span>${it[0]}</span></a>`;
  const mleaf = it => `<a class="leaf" href="${url(it)}">${adorn(it[0],it[2])}<span>${it[0]}</span></a>`;

  /* ---------- desktop mega ---------- */
  const dkNav=document.getElementById('dkNav'), dkMega=document.getElementById('dkMega');
  let megaOpen=false;
  NAV.forEach((top,i)=>{
    const a=document.createElement('a');
    a.className='dk-top'; a.href=top.url||'#'; a.textContent=top.label; a.dataset.i=i;
    a.addEventListener('mouseenter',()=>openMega(i));
    a.addEventListener('focus',()=>openMega(i));
    dkNav.appendChild(a);
    dkMega.appendChild(buildMegaPanel(top));
  });
  function buildMegaPanel(top){
    const wide = top.groups && top.groups.length>5;
    const p=document.createElement('div');
    p.className='dk-panel'+(top.feature?'':' no-feature')+(wide?' wide':'');
    let html='';
    if(top.feature){
      const f=top.feature;
      const cls = f.image ? 'dk-feature has-img' : 'dk-feature';
      const sty = f.image ? ` style="background-image:url('${f.image}')"` : '';
      html+=`<a class="${cls}" href="${f.url||'#'}"${sty}><div class="fe">${f.eyebrow||''}</div><h3>${f.title||''}</h3><p>${f.text||''}</p><span class="go">${f.cta||'Explore'}</span><span class="gem">${GEM}</span></a>`;
    }
    html+=`<div class="dk-cols"${wide?` style="grid-template-columns:repeat(${top.groups.length},minmax(0,1fr))"`:''}>`;
    if(top.groups){
      top.groups.forEach(g=>{
        html+=`<div class="dk-colblock"><div class="dk-col-h">${g.label}</div>`;
        g.items.forEach(it=> html+=dleaf(it));
        if(g.shopAll) html+=`<a class="dk-shopall" href="${g.shopAll[1]||'#'}">${g.shopAll[0]}</a>`;
        html+=`</div>`;
      });
    } else {
      const items=top.flat||[], cols=Math.max(1,Math.ceil(items.length/7)), per=Math.ceil(items.length/cols);
      for(let i=0;i<items.length;i+=per){
        html+=`<div class="dk-colblock">`;
        items.slice(i,i+per).forEach(it=> html+=dleaf(it));
        html+=`</div>`;
      }
    }
    html+=`</div>`;
    p.innerHTML=html;
    return p;
  }
  function openMega(i){
    [...dkMega.children].forEach((c,ci)=>c.classList.toggle('active',ci===i));
    [...dkNav.children].forEach((c,ci)=>c.classList.toggle('is-open',ci===i));
    const isMini = !!NAV[i].mini;
    dkMega.classList.toggle('mini', isMini);
    if(isMini){
      const btn=dkNav.children[i].getBoundingClientRect();
      const hd=dkHeaderEl.getBoundingClientRect();
      dkMega.style.right='auto'; dkMega.style.left='0px';
      const w=dkMega.getBoundingClientRect().width, vw=window.innerWidth, gut=16;
      let leftVp=btn.left;
      if(leftVp + w > vw - gut) leftVp = vw - gut - w;
      leftVp = Math.max(gut, leftVp);
      dkMega.style.left=(leftVp - hd.left)+'px';
    } else { dkMega.style.left=''; dkMega.style.right=''; }
    dkMega.classList.add('show'); megaOpen=true; updateHeader();
  }
  function closeMega(){dkMega.classList.remove('show');[...dkNav.children].forEach(c=>c.classList.remove('is-open'));megaOpen=false;updateHeader();}

  const dkHeaderEl=document.getElementById('dkHeader');
  const overHero = root.classList.contains('over-hero');
  // Pin the header-region wrapper (its parent is the tall page container, so sticky works across the page).
  const stickyEl = root.closest('.header-sections') || root.closest('.shopify-section') || root.parentElement;
  if(stickyEl){ stickyEl.style.position='sticky'; stickyEl.style.top='0'; stickyEl.style.zIndex='60'; }
  // On the homepage, pull the first content section up so the transparent header overlays it.
  let heroEl=null;
  if(overHero && stickyEl){
    heroEl = stickyEl.nextElementSibling;
    const applyOverlay=()=>{ if(heroEl) heroEl.style.marginTop = (-stickyEl.offsetHeight)+'px'; };
    applyOverlay();
    window.addEventListener('resize', applyOverlay);
    window.addEventListener('load', applyOverlay);
  }
  function updateHeader(){
    if(!overHero) return;
    const threshold = heroEl ? Math.max(40, heroEl.offsetHeight - stickyEl.offsetHeight - 10) : 200;
    root.classList.toggle('solid', window.scrollY > threshold || megaOpen);
  }
  window.addEventListener('scroll', updateHeader, {passive:true});
  window.addEventListener('resize', updateHeader);
  if(dkHeaderEl){ dkHeaderEl.addEventListener('mouseleave', closeMega); }
  document.addEventListener('keydown', e=>{ if(e.key==='Escape'){ closeMega(); closeDrawer(); } });
  updateHeader();

  /* ---------- mobile drawer (one-deep slide) ---------- */
  const navList=document.getElementById('psNavList');
  const panels=document.getElementById('psPanels');
  const rootPanel=document.getElementById('psRootPanel');
  if(navList){
    NAV.forEach(top=>{
      const btn=document.createElement('button');
      btn.className='nav-row'; btn.type='button';
      btn.innerHTML=`<span>${top.label}</span>${chev}`;
      btn.addEventListener('click',()=>openSub(top.label));
      navList.appendChild(btn);
      panels.appendChild(buildSub(top));
    });
  }
  function buildSub(top){
    const p=document.createElement('div'); p.className='panel sub'; p.id='sub-'+slug(top.label);
    let inner=`<button class="back" type="button" data-back>${backArrow}<span>${top.label}</span></button><div class="sub-scroll" data-scroll>`;
    if(top.groups){
      top.groups.forEach(g=>{
        inner+=`<div class="group"><div class="group-label">${g.label}</div>`;
        g.items.forEach(it=> inner+=mleaf(it));
        inner+=`</div>`;
      });
    } else {
      inner+=`<div class="group">`;
      (top.flat||[]).forEach(it=> inner+=mleaf(it));
      inner+=`</div>`;
    }
    inner+=`<div class="sub-pad"></div></div><div class="scroll-fade" data-fade>${fadeChev}</div>`;
    p.innerHTML=inner;
    p.querySelector('[data-back]').addEventListener('click',closeSub);
    const sc=p.querySelector('[data-scroll]'), fade=p.querySelector('[data-fade]');
    const upd=()=>fade.classList.toggle('show', sc.scrollHeight - sc.clientHeight - sc.scrollTop > 8);
    sc.addEventListener('scroll',upd);
    p._upd=upd;
    return p;
  }
  let activeSub=null;
  function openSub(label){
    const p=document.getElementById('sub-'+slug(label)); if(!p) return;
    if(activeSub) activeSub.classList.remove('open');
    p.classList.add('open'); rootPanel.classList.add('pushed');
    const sc=p.querySelector('[data-scroll]'); if(sc) sc.scrollTop=0;
    activeSub=p;
    requestAnimationFrame(()=>requestAnimationFrame(()=>{ if(p._upd) p._upd(); }));
  }
  function closeSub(){ if(activeSub){ activeSub.classList.remove('open'); activeSub=null; } if(rootPanel) rootPanel.classList.remove('pushed'); }

  const drawer=document.getElementById('psDrawer'), overlay=document.getElementById('psOverlay');
  function openDrawer(){ if(drawer){drawer.classList.add('open');overlay.classList.add('show');document.documentElement.style.overflow='hidden';} }
  function closeDrawer(){ if(drawer){drawer.classList.remove('open');overlay.classList.remove('show');document.documentElement.style.overflow='';setTimeout(closeSub,340);} }
  const burger=document.getElementById('psBurger'), closeBtn=document.getElementById('psClose');
  if(burger) burger.addEventListener('click',openDrawer);
  if(closeBtn) closeBtn.addEventListener('click',closeDrawer);
  if(overlay) overlay.addEventListener('click',closeDrawer);
  window.addEventListener('resize',()=>{ if(activeSub&&activeSub._upd) activeSub._upd(); });
})();
